export var VaultProtectionMode;
(function (VaultProtectionMode) {
    VaultProtectionMode["VAULT_PROTECTION_MODE_NONE"] = "NONE";
    VaultProtectionMode["VAULT_PROTECTION_MODE_VAULT_LOCK_GOVERNANCE"] = "VAULT_LOCK_GOVERNANCE";
    VaultProtectionMode["VAULT_PROTECTION_MODE_VAULT_LOCK_COMPLIANCE"] = "VAULT_LOCK_COMPLIANCE";
    VaultProtectionMode["VAULT_PROTECTION_MODE_LOGICALLY_AIR_GAPPED"] = "LOGICALLY_AIR_GAPPED";
})(VaultProtectionMode || (VaultProtectionMode = {}));
